export const USER_STATUS_IN_PROJECT = {
	active: "ACTIVE",
	pending: "PENDING",
	blocked: "BLOCKED",
};
export const INFORMATION_BOX_KEYS = {
	USER_PROFILE: "USER_PROFILE",
	INITIALIZATION: "INITIALIZATION",
	SUMMARY: "SUMMARY",
	REQ_REVIEW: "REQ_REVIEW",
	REQ_VALIDATION: "REQ_VALIDATION",
	DOCUMENTS: "DOCUMENTS",
	TEAM: "TEAM",
};
